import {
  Component,
  Input,
  output,
  ChangeDetectionStrategy,
} from "@angular/core";
import { SelectItem } from "primeng/api";
import { quoteListFilter } from "./quote-list-filter.const";
import { Bind } from "primeng/bind";
import { Select } from "primeng/select";
import { Chip } from "primeng/chip";
import { FormsModule } from "@angular/forms";

@Component({
  selector: "app-quote-list-filter",
  templateUrl: "./quote-list-filter.component.html",
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [Bind, Select, Chip, FormsModule],
})
export class QuoteListFilterComponent {
  @Input() filterValue: string;
  readonly filterChange = output<string>();

  public options: SelectItem[] = [
    {
      label: "Quotes",
      value: quoteListFilter.myQuotes,
    },
    {
      label: "Accounts",
      value: quoteListFilter.myClientQuotes,
    },
    {
      label: "Agents",
      value: quoteListFilter.myAgentsQuotes,
    },
    {
      label: "Team",
      value: quoteListFilter.myTeamsQuotes,
    },
  ];

  public onChange(event) {
    this.filterChange.emit(event.value);
  }

  public clearFilter() {
    this.filterValue = null;
    this.filterChange.emit(null);
  }

  public getFilterLabel(filter: string): string {
    return this.options.find((option) => option.value === filter)?.label ?? "";
  }
}
